<template>
    <div
        class="flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium"
        :class="[textClass, bgClass]"
    >
        <svg
            v-if="before < now"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-trending-up h-3 w-3"
            aria-hidden="true"
        >
            <path d="M16 7h6v6"></path>
            <path d="m22 7-8.5 8.5-5-5L2 17"></path>
        </svg>
        <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-trending-down h-3 w-3"
            aria-hidden="true"
        >
            <path d="M16 17h6v-6"></path>
            <path d="m22 17-8.5-8.5-5 5L2 7"></path>
        </svg>
        {{ deltaDirection
        }}{{ Math.round((props.now / props.before) * 1000) / 10 }}%
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
    before: {
        type: Number,
        required: true,
    },
    now: {
        type: Number,
        required: true,
    },
    inverted: {
        type: Boolean,
        required: false,
    },
    informative: {
        type: Boolean,
        required: false,
    },
});

const hasPositiveRate = computed(() => {
    return !props.inverted
        ? props.before < props.now
        : props.before > props.now;
});

const textClass = computed(() => {
    if (props.informative) {
        return "text-blue-700";
    } else if (!hasPositiveRate.value) {
        return "text-red-700";
    } else {
        return "text-green-700";
    }
});

const bgClass = computed(() => {
    if (props.informative) {
        return "bg-blue-50";
    } else if (!hasPositiveRate.value) {
        return "bg-red-50";
    } else {
        return "bg-green-50";
    }
});

const deltaDirection = computed(() => {
    if (props.before > props.now) {
        return "-";
    } else {
        return "+";
    }
});
</script>
